import { FC } from 'react';

import { AiFillCloseCircle } from 'react-icons/ai';
import cn from 'classnames';

type PROPS = {
  emailAddress: string;
};

const ClientBookingLinkExpired: FC<PROPS> = ({
  emailAddress = 'admin@leapify.com',
}) => (
  <div
    className={cn(
      'max-w-[404px]',
      'bg-fill-tertiary',
      'p-12',
      'rounded-[6px]',
      'shadow-leapify-sm',
      'text-secondary-base',
      'flex flex-col',
      'items-center justify-center',
    )}
  >
    <AiFillCloseCircle className="h-[100px] w-[100px] text-danger-base" />
    <div className="mt-2 text-[22px] font-bold leading-7 tracking-[0.88px]">
      LINK EXPIRED
    </div>
    <div className="mt-6 text-center font-semibold leading-[22px] tracking-[0.56px]">
      <p className="text-sm">Link has expired.</p>
      <span className="text-sm">
        If you have any questions email{' '}
        <a
          className="text-sm hover:text-primary-base"
          href={`mailto:@${emailAddress}`}
        >
          {emailAddress}
        </a>
      </span>
    </div>
  </div>
);

export default ClientBookingLinkExpired;
